import {List, Map, Record} from 'immutable';

import { ActionTypes, DRCStates } from '../constants/AppConstants';
import BaseStore from './BaseStore';


let cachedRailcards = new Record({
    cards: null,
    types: new Map(),
    digitalRailcards: new List()
})();

class RailcardsStore extends BaseStore {

    getActionHandlers () {
        return {
            [ActionTypes.ACCOUNT_RAILCARDS_LOADED]: this.handleAccountRailcardsLoaded,
            [ActionTypes.ACCOUNT_RAILCARD_DELETED]: this.handleAccountRailcardDeleted,
            [ActionTypes.RAILCARDS_LOADED]: this.handleLoaded,
            [ActionTypes.ACCOUNT_DRC_LOADED]: this.handleDRCLoaded,
            [ActionTypes.SET_FAVOURITE_DRC]: this.handleSetFavourite,
            [ActionTypes.REMOVED_DRC_DEVICE]: this.removeDrcDevice
        };
    }

    handleAccountRailcardsLoaded ({ accountRailcards }) {
        this.setState(this.state.set('accountRailcards', accountRailcards).set('accountRailcardsLoaded', true));
    }

    handleAccountRailcardDeleted ({ accountRailcard }) {
        const current = this.getAccountRailcards();
        const index = current.indexOf(accountRailcard);
        const accountRailcards = current.delete(index);
        this.handleAccountRailcardsLoaded({ accountRailcards });
    }

    getAccountRailcards () {
        return this.state.get('accountRailcards', new List());
    }

    getAccountRailcardsLoaded () {
        return this.state.get('accountRailcardsLoaded', false);
    }

    handleDRCLoaded ({ railcards }) {
        cachedRailcards = cachedRailcards.set('digitalRailcards', new List(railcards));
        this.emitChange();
    }

    getFavouriteDRC () {
        return cachedRailcards.get('digitalRailcards').filter(({ isFavourite }) => isFavourite).first();
    }

    handleSetFavourite({ railcardId }) {
        const mappedDRC = cachedRailcards.get('digitalRailcards').map(drc => {
            drc.isFavourite = drc.id === railcardId ? !drc.isFavourite : false;
            return drc;
        });

        cachedRailcards = cachedRailcards.set('digitalRailcards', mappedDRC);
        this.emitChange();
    }

    getAllDRC () {
        return cachedRailcards.get('digitalRailcards');
    }

    getNonPendindDRC () {
        return this.getAllDRC().filter(({ state }) => state !== DRCStates.PENDING);
    }

    removeDrcDevice({ railcardId, device1Id, device2Id }) {
        const mappedDRC = cachedRailcards.get('digitalRailcards').map(drc => {
            if (drc.id === railcardId) {
                if (device1Id) {
                    drc.device1 = null;
                }

                if (device2Id) {
                    drc.device2 = null;
                }
            }

            return drc;
        });

        cachedRailcards = cachedRailcards.set('digitalRailcards', mappedDRC);

        this.emitChange();
    }

    handleLoaded ({ railcards, smartcard }) {
        const type = smartcard ? 'smartcard' : 'all';
        const cards = railcards.reduce(
            (acc, card) => acc.set(card.code, card),
            cachedRailcards.cards || new Map()
        );

        cachedRailcards = cachedRailcards.set('cards', cards).setIn(['types', type], railcards);
        this.emitChange();
    }

    getAll ({ smartcard = null } = {}) {
        const type = smartcard ? 'smartcard' : 'all';
        return cachedRailcards.getIn(['types', type]);
    }

    getSome ({ smartcard, filterOutRailcards = [] }) {
        const type = smartcard ? 'smartcard' : 'all';
        const railcards = cachedRailcards.getIn(['types', type]);
        return railcards ? railcards.filter(({ code }) => !filterOutRailcards.includes(code)) : null;
    }

    get (code) { return cachedRailcards.cards.get(code); }


}

const storeInstance = new RailcardsStore();

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/RailcardsStore.js